<template>
    <div class="modal-container has-text-centered">
        <div class="has-text-dark  bottom20">
           <div class="has-background-dark pad10"> <div class="is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3 has-text-white"> DELETE MIIMU</span></div></div>
        </div>

       <div class="has-text-left is-inline-block marginAutod">
            <div>
                <input type="radio" name="sel" value="curr" class="vTop radio" style="position: relative; top: 2px" @click="selected = 'curr'" checked>&nbsp;Delete from this bundle only
            </div>
           
            <div> <input type="radio" name="sel" value="all" class="vTop" style="position: relative; top: 2px" @click="selected = 'all'">&nbsp;Delete from all bundles</div>
       </div>
       <br>
        <button class="button is-small top20 is-coolGreen" @click="delIt" id="delButt">DELETE</button>&nbsp;
        <button class="button is-small top20" @click="cancel">CANCEL</button>
        <div>&nbsp;</div>
    </div>
</template>


<script>

export default {

    props:{
        callBack: Function,
        id: Number
    },

    data: function(){
        return {
            selected: 'curr'
        }
    },

   
    methods: {
        cancel: function(){
            this.$emit('close');
        },
        delIt: function(){
            this.callBack(this.selected, this.id)
        },

    }

}

</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }

</style>